import React from 'react';

import LoadingOverlay from 'components/LoadingOverlay';
import { Step } from 'components/SteppedModal';
import { FacebookAutomationModalStep } from './types';

const useAuthenticationProgressStep = (): Step<FacebookAutomationModalStep> => {
  return {
    id: 'authentication-in-progress',
    title: 'Authenticating with Facebook',
    fluidFooterButtons: true,
    hideFooter: true,
    component: <LoadingOverlay small />,
  };
};

export default useAuthenticationProgressStep;
